var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7086 2.85157C17.1772 2.38294 17.1772 1.62315 16.7086 1.15452C16.24 0.685887 15.4802 0.685887 15.0115 1.15452L8.93322 7.23284L2.85185 1.15148C2.38322 0.682846 1.62342 0.682846 1.15479 1.15147C0.686165 1.6201 0.686166 2.3799 1.15479 2.84853L7.23616 8.9299L1.15225 15.0138C0.683624 15.4824 0.683624 16.2422 1.15225 16.7109C1.62088 17.1795 2.38068 17.1795 2.84931 16.7109L8.93322 10.627L15.0141 16.7078C15.4827 17.1765 16.2425 17.1765 16.7111 16.7078C17.1798 16.2392 17.1798 15.4794 16.7111 15.0108L10.6303 8.9299L16.7086 2.85157Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bb1350713a368074232db5c4344045a0.svg";
export { ForwardRef as ReactComponent };